import { useSelector } from 'react-redux';

import {
  getCanManageOauthClients,
  getCanManagePersonalAccessTokens,
  getCanManageWebhooks,
} from 'store/features/session/selectors';

export interface IUseCanManageApi {
  canManagePersonalAccessTokens: boolean;
  canManageOauthClients: boolean;
  canManageWebhooks: boolean;
  canManageApi: boolean;
}

/**
 * Permission gate for the "API access" section, backed by the account's scopes:
 * `personal_access_manage` and `oauth_clients_manage` (webhooks reuse the existing
 * `webhooks_manage` gate). Returns granular flags so each tab can decide its own
 * visibility while the section entry point shows whenever any area is available.
 */
export const useCanManageApi = (): IUseCanManageApi => {
  const canManagePersonalAccessTokens = useSelector(getCanManagePersonalAccessTokens);
  const canManageOauthClients = useSelector(getCanManageOauthClients);
  const canManageWebhooks = useSelector(getCanManageWebhooks);

  return {
    canManagePersonalAccessTokens,
    canManageOauthClients,
    canManageWebhooks,
    canManageApi: canManagePersonalAccessTokens || canManageOauthClients || canManageWebhooks,
  };
};
